class HelpCenterWidget extends HTMLElement {
  connectedCallback() {
    this.screens = Array.from(this.querySelectorAll('[data-screen]'));
    this.searchIndex = Array.from(this.querySelectorAll('[data-article-screen]')).map((el) => ({
      id: el.getAttribute('data-article-screen'),
      text: el.getAttribute('data-search-text') || '',
      title: el.querySelector('.hc-article h3') ? el.querySelector('.hc-article h3').textContent : ''
    }));

    this.addEventListener('click', this.onClick.bind(this));
    this.querySelectorAll('.hc-search-input').forEach((input) => {
      input.addEventListener('input', this.onSearchInput.bind(this));
    });

    this.showScreen({ screen: 'home' });
  }

  onClick(event) {
    const faqsTrigger = event.target.closest('[data-nav-faqs]');
    if (faqsTrigger) {
      event.preventDefault();
      this.showScreen({ screen: 'faqs' });
      return;
    }

    const orderTrigger = event.target.closest('[data-nav-order]');
    if (orderTrigger) {
      event.preventDefault();
      this.showScreen({ screen: 'order' });
      return;
    }

    const categoryTrigger = event.target.closest('[data-nav-category]');
    if (categoryTrigger) {
      this.showScreen({ screen: 'category', id: categoryTrigger.getAttribute('data-nav-category') });
      return;
    }

    const articleTrigger = event.target.closest('[data-nav-article]');
    if (articleTrigger) {
      event.preventDefault();
      this.showScreen({ screen: 'article', id: articleTrigger.getAttribute('data-nav-article') });
      return;
    }

    const backToCategory = event.target.closest('[data-back-to-category]');
    if (backToCategory) {
      this.showScreen({ screen: 'category', id: backToCategory.getAttribute('data-back-to-category') });
      return;
    }

    const backTo = event.target.closest('[data-back-to]');
    if (backTo) {
      this.showScreen({ screen: backTo.getAttribute('data-back-to') });
      return;
    }
  }

  onSearchInput(event) {
    const rawValue = event.target.value;
    const query = rawValue.trim().toLowerCase();

    // Keep every search box (one per screen) in sync so whichever one
    // becomes visible next always shows what the visitor actually typed.
    this.querySelectorAll('.hc-search-input').forEach((input) => {
      if (input !== event.target) input.value = rawValue;
    });

    if (query.length < 2) {
      if (this.currentScreenName() === 'search') this.showScreen({ screen: 'faqs' });
      return;
    }

    const results = this.searchIndex.filter((item) => item.text.includes(query)).slice(0, 20);
    const resultsContainer = this.querySelector('[data-search-results]');
    resultsContainer.innerHTML = '';

    if (!results.length) {
      const empty = document.createElement('p');
      empty.className = 'hc-empty';
      empty.textContent = 'No results found.';
      resultsContainer.appendChild(empty);
    } else {
      results.forEach((item) => {
        const row = document.createElement('button');
        row.type = 'button';
        row.className = 'hc-row';
        row.setAttribute('data-nav-article', item.id);
        const label = document.createElement('span');
        label.textContent = item.title;
        const chevron = document.createElement('span');
        chevron.className = 'hc-chevron';
        chevron.innerHTML = '<i class="fa-solid fa-chevron-right" aria-hidden="true"></i>';
        row.appendChild(label);
        row.appendChild(chevron);
        resultsContainer.appendChild(row);
      });
    }

    if (this.currentScreenName() !== 'search') {
      this.showScreen({ screen: 'search' });
    }
  }

  currentScreenName() {
    const active = this.querySelector('.hc-screen.hc-active');
    return active ? active.getAttribute('data-screen') : 'home';
  }

  showScreen(entry) {
    // Hiding the screen that currently contains focus (display: none) makes the
    // browser drop focus entirely, so any further keystrokes go nowhere and the
    // last character typed gets stuck. Remember it so we can hand focus to the
    // matching input on the new screen instead.
    const activeElement = document.activeElement;
    const wasSearchFocused = !!(activeElement && activeElement.classList && activeElement.classList.contains('hc-search-input'));

    this.screens.forEach((el) => el.classList.remove('hc-active'));

    let target = null;
    if (entry.screen === 'category') {
      target = this.querySelector('[data-category-screen="' + entry.id + '"]');
    } else if (entry.screen === 'article') {
      target = this.querySelector('[data-article-screen="' + entry.id + '"]');
    } else {
      target = this.querySelector('[data-screen="' + entry.screen + '"]');
    }

    if (!target) return;
    target.classList.add('hc-active');

    if (wasSearchFocused) {
      const nextInput = target.querySelector('.hc-search-input');
      if (nextInput) {
        nextInput.focus();
        const cursor = nextInput.value.length;
        nextInput.setSelectionRange(cursor, cursor);
      }
    }
  }
}

customElements.define('help-center-widget', HelpCenterWidget);
